import { textFormatting } from '@yola/ws-sdk';
import unwrapElement from './unwrap-element';
import getElementTypeOptions from './get-element-type-options';
import getTypedElementSelector from './get-typed-element-selector';
import findTypedParentElements from './find-typed-parent-elements';
import removeFontSizeFromNode from './remove-font-size-from-node';
import removeTextIndentModifierFromNode from './remove-text-indent-modifier-from-node';
import removeLineAndParagraphSpacingFromNode from './remove-line-and-paragraph-spacing-from-node';

const { wrappersTypes } = textFormatting.constants;
const { isWrapperRegistered } = textFormatting.verifiers;

const clearFormatting = (selection, elementId, breakpoint) => {
  const elementTypeOptions = getElementTypeOptions(elementId);
  const typedElementSelector = getTypedElementSelector(elementTypeOptions);
  const focusElements = findTypedParentElements(typedElementSelector, selection);

  focusElements.forEach((node) => {
    removeFontSizeFromNode(node);
    removeTextIndentModifierFromNode(node);
    removeLineAndParagraphSpacingFromNode(node, breakpoint);
  });

  Object.keys(wrappersTypes).forEach((key) => {
    if (key === 'link') return;

    const { id } = wrappersTypes[key];

    if (id === wrappersTypes.customColor.id) {
      unwrapElement(selection, elementId, wrappersTypes.customColor);
      return;
    }
    if (id === wrappersTypes.decoration.id) {
      unwrapElement(selection, elementId, wrappersTypes.decoration);
      return;
    }
    if (!isWrapperRegistered(id)) return;

    textFormatting.operations.undoWrapper(id);
  });
};

export default clearFormatting;
